export class Datei {
    file: File = null;
    error: boolean = false;
}
